import { Api } from "../config/request";

export default {
  getGigsSupportList(queryParams) {
    return Api.get(`/driver-shift/slot/rider-slot-details${queryParams}`);
  },
};
